module.exports = __webpack_public_path__ + "img/sign-43.714916e0.jpg";